import styled from 'styled-components'

export const Loading = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    p {
        padding-top: 5px;
        color: var(--gray-700);
        font-size: 13px;
    }

    i {
        color: var(--gray-500);
        font-size: 48px;
    }
`

export const BowtieEditorDiv = styled.div`
    position: relative;
    width: 100%;
    height: calc(100% - 40px);
    overflow: hidden;
    display: flex;
    flex-direction: row;
    padding: 5px;
    background: var(--gray-300);

    .diagram-template {
        position: relative;
        flex-direction: column;
        width: calc(100% - 400px);
        flex-grow: 1;
        border-top-left-radius: 5px;
        border-bottom-left-radius: 5px;
        overflow: hidden;
        border-top: 2px solid var(--gray-500);
        border-left: 2px solid var(--gray-500);
        border-bottom: 2px solid var(--gray-500);

        svg#bowtie-svg {
            background: var(--gray-200);
            cursor: move;

            #bowtie-container {
                .hazardLine {
                    stroke: var(--yellow-500);
                    stroke-width: 2px;
                    stroke-dasharray: 5 5;
                    opacity: 0.5;
                }

                .hazardAuxLine {
                    stroke: var(--gray-400);
                    stroke-width: 2px;
                    stroke-dasharray: 5 5;
                    opacity: 0.5;
                }
            }
        }
    }

    .diagram-list {
        flex-direction: column;
        width: 400px;
        flex-grow: 1;
        z-index: 1;
        box-shadow: -2px 0px 8px rgba(0, 0, 0, 0.12);
        background: var(--gray-0);
        border-top-right-radius: 5px;
        border-bottom-right-radius: 5px;
        overflow: hidden;
        border-top: 2px solid var(--gray-500);
        border-right: 2px solid var(--gray-500);
        border-bottom: 2px solid var(--gray-500);
    }
`
export const AlarmGroupListDropdown = styled.div`
    position: relative;
    .button-dropdown-notification {
        border: none;
        display: flex;
        gap: 16px;
        min-width: 180px;
        align-items: center;
        .fa-caret-down {
            color: ${({ theme }) => theme['blue-500']};
        }
        &:hover {
            cursor: pointer;
        }
    }
`

export const DivDropdownAlarmGroup = styled.div<{ show: boolean }>`
    max-height: 8em;
    overflow-y: scroll;
    width: 17em;
    z-index: 9000;
    background: ${({ theme }) => theme['gray-0']};
    display: ${({ show }) => (show ? 'flex' : 'none')};
    flex-direction: column;
    position: absolute;
    font-size: 12px;
    font-weight: 400;
    top: 29px;
    left: -12px;
    gap: 16px;
    padding: 8px;
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.2);
`
